import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=7c772ca0&"
import script from "./StoresList.vue?vue&type=script&lang=js&"
export * from "./StoresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports